import { call, put } from "redux-saga/effects";
import uuidv4 from "uuid/v4";
import { errorAction } from "./errorActions";

/**
 * @param {*} action Redux action
 * @param {*} actualSaga A function accepting action and requestInfo (token and correlationId)
 * @param {*} errorActionType Action type to be dispatched in case of error
 */
function* genericSaga(action, actualSaga, errorActionType) {
  const correlationId = uuidv4();

  try {
    const requestInfo = { correlationId, includeToken: true };

    yield call(actualSaga, action, requestInfo);
  } catch (e) {
    yield put(errorAction(errorActionType, e, correlationId, action));
  }
}

export const doCall = (actualSaga, errorType) => {
  return function*(action) {
    yield genericSaga(action, actualSaga, errorType, true);
  };
};
